<template>
  <div class="hidden-gems-block">
    <div class="container">
      <h3>Hidden GEMs</h3>
      <h2>A Treasure Hunt Like No&nbsp;Other</h2>
      <p>Some treasures are waiting to be found. <span>Others… are waiting to find you.</span></p>
      <div class="cards">
        <div class="card">
          <div class="image">
            <img src="./images/gems-icon-1.svg">
          </div>
          <div class="content">
            <strong>GEMs of TRUE WORLD</strong>
            <p>Ancient artifacts scattered across dimensions, holding secrets of unimaginable power.</p>
          </div>
        </div>
        <div class="card">
          <div class="image">
            <img src="./images/gems-icon-2.svg">
          </div>
          <div class="content">
            <strong>Legendary Rewards</strong>
            <p>Unlock exclusive in-game assets, digital treasures, and real-world surprises.</p>
          </div>
        </div>
        <div class="card">
          <div class="image">
            <img src="./images/gems-icon-3.svg">
          </div>
          <div class="content">
            <strong>Only for the Worthy</strong>
            <p>Some paths appear only to those who dare to seek them.</p>
          </div>
        </div>
        <div class="card">
          <div class="content">
            <div class="last-nfts">
              <div class="block-title">
                <div class="title">Recent Discoveries</div>
              </div>
              <div class="table-wrapper">
                <div class="table">
                  <transition-group name="list" tag="div" class="tbody">
                    <div
                        class="tr"
                        v-for="(row, index) in showData"
                        :key="row.id"
                    >
                      <router-link
                          :to="{name: 'nft', params: { id: row['slug'] }}"
                          class="td"
                          :class="'td-'+data.headers[idx]"
                          v-for="(item, name, idx) in row"
                          :key="idx + '_item_td'"
                          v-if="data.headers[idx]"
                      >
                        <template v-if="data.headers[idx] === 'image'">
                          <div class="shadow"></div>
                          <img :src="row['image']" :alt="row['name']" @error="imageUrlAlt">
                        </template>
                        <template v-else-if="data.headers[idx] === 'name'">
                          <div>
                            <span>{{ row['name'] }}</span>
                            <span><span>Crafted by&nbsp;</span> <strong>{{ row['user'] }}</strong></span>
                            <span :title='$moment.unix(row["date"]).format("MMMM DD YYYY, HH:mm")'>{{ $moment.unix(row["date"]).format("MMMM DD YYYY, HH:mm") }}</span>
                          </div>
                        </template>
                      </router-link>
                    </div>
                  </transition-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buttons">
        <router-link :to="{ name: 'collection', params: { id: 'gems' } }">Find Your First GEM</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header-block',
  data() {
    return {
      data: {
        headers: [
          "image",
          "name",
        ],
        content: [
        ]
      },
      showData: [],
      firstLoad: true,
    }
  },
  methods: {
    getLastMintedNfts: async function() {
      await this.$request.get('/true-world/last-minted-nfts', null, response => {
        if(this.firstLoad) {
          this.data.content = response
          if(response) {
            this.showData = this.data.content.slice(this.data.content.length-5, this.data.content.length)
          } else this.showData = [];
          this.firstLoad = false;
        } else {
          let newElems = [];

          response.forEach((item) => {
            if (this.data.content.map(e => e.id).indexOf(item.id) === -1) {
              newElems.push(item)
            }
          })

          newElems.forEach((newItem) => {
            this.data.content.unshift(newItem);
          })

          const it = newElems[Symbol.iterator](); // convenient for yeilding values
          const int = setInterval(() => { // time interval
            const next = it.next(); // next value
            if (!next.done) { // done = true when the end of array reached
              this.showData.unshift(next.value)
              this.showData = this.showData.slice(0, 5)
            } else {
              clearInterval(int);
            }
          }, 3000);
        }
      }, error => {
        console.log(error);
      })
    },
    appendLastMintedNft: function() {
      if(this.data.content.length) {
        const it = this.data.content.slice(0, this.data.content.length-5).reverse()[Symbol.iterator](); // convenient for yeilding values
        const int = setInterval(() => {
          const next = it.next();
          if (!next.done) {
            this.showData.unshift(next.value)
            this.showData = this.showData.slice(0, 5)
          } else {
            clearInterval(int);
          }
        }, 3000);
      }
    },
    imageUrlAlt: (event) => {
      event.target.src = require("./images/no-image.png");
    }
  },
  async mounted() {
    this.$moment.updateLocale('en', {
      relativeTime : {
        future: "in %s",
        past:   "%s ago",
        s  : 'a few seconds',
        ss : '%d seconds',
        m:  "a minute",
        mm: "%d minutes",
        h:  "1 hour", //this is the setting that you need to change
        hh: "%d hours",
        d:  "a day",
        dd: "%d days",
        w:  "a week",
        ww: "%d weeks",
        M:  "1 month", //change this for month
        MM: "%d months",
        y:  "a year",
        yy: "%d years"
      }
    });

    await this.getLastMintedNfts();
    this.appendLastMintedNft();
    setInterval(() => { this.getLastMintedNfts() }, 16000);
  }
}
</script>

<style lang="less" scoped>
  .hidden-gems-block {
    padding-top: 0;
    padding-bottom: 150px;

    > .container {
      > h3 {
        font-family: 'Poppins';
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 45px;
        text-align: center;
        margin-bottom: 2px;
        background: linear-gradient(90.62deg, #DF60FF 0%, #9C94FF 49.03%, #44E9C3 62.94%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-fill-color: transparent;
      }
      > h2 {
        color: #FFF;
        font-family: Poppins;
        font-weight: 700;
        font-size: 50px;
        line-height: 64px;
        text-align: center;
        margin-bottom: 16px;
      }
      > p {
        color: #FFFFFF99;
        font-family: Poppins;
        font-weight: 500;
        font-size: 24px;
        line-height: 38px;
        text-align: center;
        margin-bottom: 50px;
        > span {
          color: #FFF;
          font-weight: 600;
        }
      }
      > .cards {
        display: grid;
        grid-template-columns: repeat(2fr, 1fr);
        grid-template-rows: repeat(3, 1fr);
        gap: 20px;
        margin-bottom: 40px;
        > .card {
          &:nth-child(1) { grid-area: ~"1 / 1 / 2 / 2"; }
          &:nth-child(2) { grid-area: ~"2 / 1 / 3 / 2"; }
          &:nth-child(3) { grid-area: ~"3 / 1 / 4 / 2"; }
          &:nth-child(4) { grid-area: ~"1 / 2 / 4 / 3"; width: 380px; justify-content: flex-start; align-items: flex-start; }
          background: #C9D8FF0F;
          border-radius: 30px;
          padding: 24px 30px;
          display: flex;
          gap: 20px;
          align-items: center;
          justify-content: center;
          > .image {
            > img {
              display: block;
            }
          }
          > .content {
            width: 100%;
            > strong {
              display: block;
              color: #FFF;
              font-family: Poppins;
              font-weight: 700;
              font-size: 20px;
              line-height: 28px;
              margin-bottom: 6px;
            }
            > p {
              color: #FFFFFF99;
              font-family: Poppins;
              font-weight: 500;
              font-size: 18px;
              line-height: 28px;
            }
            > .last-nfts {
              overflow: hidden;

              > .block-title {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 13px;
                gap: 10px;

                .title {
                  color: #fff;
                  font-family: Poppins;
                  font-weight: 700;
                  font-size: 24px;
                  line-height: 100%;
                  flex-grow: 1;
                }
                .td-image {
                  width: 66px;
                }
              }

              > .table-wrapper {
                margin: 0 auto;
                position: relative;
                z-index: 2;

                > .table {
                  display: flex;
                  border-radius: 15px;
                  overflow: hidden;
                  width: 100%;
                  max-height: 430px;

                  > .tbody {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    gap: 20px;

                    > .tr {
                      width: 100%;
                      display: flex;
                      flex-direction: row;
                      gap: 20px;

                      > .td {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: rgba(255, 255, 255, 1);
                        font-size: 15px;
                        font-weight: 500;
                        line-height: 23px;
                        text-align: left;
                        height: 70px;

                        &.td-image {
                          padding: 0;
                          position: relative;
                          > .shadow {
                            border-radius: 12px;
                            position: absolute;
                            display: block;
                            top: 0;
                            left: 0px;
                            width: 70px;
                            height: 70px;
                            box-shadow: inset 0 5px 16px rgba(255, 214, 109, 0.65);
                          }
                          > img {
                            border-radius: 12px;
                            width: 70px;
                            height: 70px;
                          }
                        }

                        &.td-name {
                          flex: 1;
                          justify-content: flex-start;

                          > div {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: flex-start;

                            span:first-child {
                              font-size: 12px;
                              font-weight: 500;
                              line-height: 18px;
                            }
                            span:last-child {
                              font-size: 12px;
                              font-weight: 400;
                              line-height: 18px;
                              color: #FFFFFF99;
                              display: flex;
                              > span {
                                display: inline-block;
                              }
                              > strong {
                                font-weight: 600;
                                color: #FFF;
                                max-width: 80px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                text-wrap: nowrap;
                                display: inline-block;
                              }
                            }
                          }
                        }

                        &.td-date {
                          color: rgba(255, 255, 255, 0.6);
                          width: 80px;
                          text-align: right;
                          font-size: 10px;
                          font-weight: 400;
                          line-height: 13px;
                          padding-right: 10px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      > .buttons {
        display: flex;
        gap: 10px;
        justify-content: center;
        align-items: center;
        > a {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 310px;
          height: 60px;
          border-radius: 14px;
          transition: all .2s;
          color: #fff;
          font-size: 16px;
          line-height: 24px;
          background: linear-gradient(90deg, #9D5BFF 0%, #563AE7 100%);
          &:hover {
            background: linear-gradient(90deg, #9D5BFF 20%, #563AE7 80%);
          }
        }
      }
    }
  }

  @media screen and (max-width: 1439px) {
    .hidden-gems-block {
      padding-top: 0;
      padding-bottom: 110px;

      > .container {
        > h3 {
          font-size: 24px;
          line-height: 100%;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 36px;
          line-height: 50px;
          margin-bottom: 12px;
        }
        > p {
          font-size: 18px;
          line-height: 28px;
          margin-bottom: 40px;
        }
        > .cards {
          display: grid;
          grid-template-columns: repeat(2fr, 1fr);
          grid-template-rows: repeat(3, 1fr);
          gap: 12px;
          margin-bottom: 40px;
          > .card {
            border-radius: 30px;
            padding: 24px 20px;
            gap: 20px;

            &:nth-child(4) { width: 274px; }

            > .image {
              > img {
                width: 90px;
              }
            }
            > .content {
              > strong {
                font-size: 20px;
                line-height: 28px;
                margin-bottom: 2px;
              }
              > p {
                font-size: 16px;
                line-height: 26px;
              }
              > .last-nfts {
                overflow: hidden;

                > .block-title {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 13px;
                  gap: 10px;

                  .title {
                    flex-grow: 1;
                    font-family: Poppins;
                    font-weight: 700;
                    font-size: 20px;
                    line-height: 100%;
                  }
                }

                > .table-wrapper {
                  margin: 0 auto;
                  position: relative;
                  z-index: 2;

                  > .table {
                    display: flex;
                    overflow: hidden;
                    width: 100%;
                    max-height: 382px;

                    > .tbody {
                      display: flex;
                      flex-direction: column;
                      width: 100%;
                      gap: 8px;

                      > .tr {
                        width: 100%;
                        display: flex;
                        flex-direction: row;
                        gap: 12px;

                        > .td {
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          color: rgba(255, 255, 255, 1);
                          font-size: 15px;
                          font-weight: 500;
                          line-height: 23px;
                          text-align: left;
                          height: 70px;

                          &.td-image {
                            padding: 0;
                            position: relative;
                            > .shadow {
                              top: auto;
                              border-radius: 12px;
                              width: 50px;
                              height: 50px;
                              box-shadow: inset 0 5px 16px rgba(255, 214, 109, 0.65);
                            }
                            > img {
                              border-radius: 12px;
                              width: 50px;
                              height: 50px;
                            }
                          }

                          &.td-name {
                            flex: 1;
                            justify-content: flex-start;
                            border-bottom: 1px solid #FFFFFF1A;

                            > div {
                              display: flex;
                              flex-direction: column;
                              justify-content: center;
                              align-items: flex-start;

                              > span:first-child {
                                font-family: Poppins;
                                font-weight: 700;
                                font-size: 14px;
                                line-height: 100%;
                              }
                              > span:nth-child(2) {
                                > span {
                                  font-family: Poppins;
                                  font-weight: 400;
                                  font-size: 12px;
                                  line-height: 100%;
                                }
                                > strong {
                                  font-family: Poppins;
                                  font-weight: 600;
                                  font-size: 12px;
                                  line-height: 100%;
                                }
                              }
                              > span:last-child {
                                font-family: Poppins;
                                font-weight: 400;
                                font-size: 11px;
                                line-height: 100%;
                              }
                            }
                          }

                          &.td-date {
                            color: rgba(255, 255, 255, 0.6);
                            width: 80px;
                            text-align: right;
                            font-size: 10px;
                            font-weight: 400;
                            line-height: 13px;
                            padding-right: 10px;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        > .buttons {
          display: flex;
          gap: 10px;
          justify-content: center;
          align-items: center;
          > a {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 220px;
            height: 50px;
            border-radius: 14px;
            transition: all .2s;
            color: #fff;
            font-size: 14px;
            line-height: 14px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1023px) {
    .hidden-gems-block {
      padding-top: 0;
      padding-bottom: 100px;

      > .container {
        > h3 {
          font-size: 20px;
          line-height: 100%;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 30px;
          line-height: 40px;
          margin-bottom: 10px;
        }
        > p {
          font-size: 16px;
          line-height: 26px;
          margin-bottom: 30px;
        }
        > .cards {
          display: grid;
          grid-template-columns: repeat(2fr, 1fr);
          grid-template-rows: repeat(3, 1fr);
          gap: 12px;
          margin-bottom: 40px;
          > .card {
            border-radius: 20px;
            padding: 24px 20px;
            gap: 16px;

            &:nth-child(4) { width: 212px; }

            > .image {
              > img {
                width: 90px;
              }
            }
            > .content {
              > strong {
                font-size: 16px;
                line-height: 20px;
                margin-bottom: 2px;
              }
              > p {
                font-size: 14px;
                line-height: 22px;
              }
              > .last-nfts {
                overflow: hidden;

                > .block-title {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 13px;
                  gap: 10px;

                  .title {
                    flex-grow: 1;
                    font-family: Poppins;
                    font-weight: 700;
                    font-size: 16px;
                    line-height: 100%;
                  }
                }

                > .table-wrapper {
                  margin: 0 auto;
                  position: relative;
                  z-index: 2;

                  > .table {
                    display: flex;
                    overflow: hidden;
                    width: 100%;
                    max-height: 382px;

                    > .tbody {
                      display: flex;
                      flex-direction: column;
                      width: 100%;
                      gap: 8px;

                      > .tr {
                        width: 100%;
                        display: flex;
                        flex-direction: row;
                        gap: 12px;

                        > .td {
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          color: rgba(255, 255, 255, 1);
                          font-size: 15px;
                          font-weight: 500;
                          line-height: 23px;
                          text-align: left;
                          height: 70px;

                          &.td-image {
                            padding: 0;
                            position: relative;
                            > .shadow {
                              top: auto;
                              border-radius: 12px;
                              width: 40px;
                              height: 40px;
                              box-shadow: inset 0 5px 16px rgba(255, 214, 109, 0.65);
                            }
                            > img {
                              border-radius: 12px;
                              width: 40px;
                              height: 40px;
                            }
                          }

                          &.td-name {
                            flex: 1;
                            justify-content: flex-start;
                            border-bottom: 1px solid #FFFFFF1A;

                            > div {
                              display: flex;
                              flex-direction: column;
                              justify-content: center;
                              align-items: flex-start;

                              > span:first-child {
                                font-family: Poppins;
                                font-weight: 700;
                                font-size: 13px;
                                line-height: 100%;
                                max-width: 120px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                text-wrap: nowrap;
                                display: inline-block;
                                margin-bottom: 2px;
                              }
                              > span:nth-child(2) {
                                display: flex;
                                > span {
                                  font-family: Poppins;
                                  font-weight: 400;
                                  font-size: 11px;
                                  line-height: 100%;
                                  margin-bottom: 2px;
                                }
                                > strong {
                                  font-family: Poppins;
                                  font-weight: 600;
                                  font-size: 11px;
                                  line-height: 100%;
                                }
                              }
                              > span:last-child {
                                font-family: Poppins;
                                font-weight: 400;
                                font-size: 11px;
                                line-height: 100%;
                                max-width: 120px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                text-wrap: nowrap;
                                display: inline-block;
                              }
                            }
                          }

                          &.td-date {
                            color: rgba(255, 255, 255, 0.6);
                            width: 80px;
                            text-align: right;
                            font-size: 10px;
                            font-weight: 400;
                            line-height: 13px;
                            padding-right: 0px;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        > .buttons {
          display: flex;
          gap: 10px;
          justify-content: center;
          align-items: center;
          > a {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 220px;
            height: 50px;
            border-radius: 14px;
            transition: all .2s;
            color: #fff;
            font-size: 14px;
            line-height: 14px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .hidden-gems-block {
      padding-top: 0;
      padding-bottom: 100px;

      > .container {
        > h3 {
          font-size: 14px;
          line-height: 100%;
          margin-bottom: 0;
        }
        > h2 {
          font-size: 20px;
          line-height: 26px;
          margin-bottom: 6px;
        }
        > p {
          font-size: 13px;
          line-height: 22px;
          margin-bottom: 20px;
          padding: 0 16px;
        }
        > .cards {
          display: flex;
          flex-direction: column;
          gap: 10px;
          margin-bottom: 20px;
          > .card {
            border-radius: 20px;
            padding: 16px 10px;
            gap: 10px;

            &:nth-child(4) { width: 100%; padding-left: 15px; padding-right: 15px; }

            > .image {
              > img {
                width: 50px;
              }
            }
            > .content {
              > strong {
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 2px;
              }
              > p {
                font-size: 12px;
                line-height: 20px;
              }
              > .last-nfts {
                overflow: hidden;

                > .block-title {
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 13px;
                  gap: 10px;

                  .title {
                    flex-grow: 1;
                    font-family: Poppins;
                    font-weight: 700;
                    font-size: 14px;
                    line-height: 100%;
                  }
                }

                > .table-wrapper {
                  margin: 0 auto;
                  position: relative;
                  z-index: 2;

                  > .table {
                    display: flex;
                    overflow: hidden;
                    width: 100%;

                    > .tbody {
                      display: flex;
                      flex-direction: column;
                      width: 100%;
                      gap: 8px;

                      > .tr {
                        width: 100%;
                        display: flex;
                        flex-direction: row;
                        gap: 12px;

                        > .td {
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          color: rgba(255, 255, 255, 1);
                          font-size: 15px;
                          font-weight: 500;
                          line-height: 23px;
                          text-align: left;
                          height: 70px;

                          &.td-image {
                            padding: 0;
                            position: relative;
                            > .shadow {
                              top: auto;
                              border-radius: 12px;
                              width: 50px;
                              height: 50px;
                              box-shadow: inset 0 5px 16px rgba(255, 214, 109, 0.65);
                            }
                            > img {
                              border-radius: 12px;
                              width: 50px;
                              height: 50px;
                            }
                          }

                          &.td-name {
                            flex: 1;
                            justify-content: flex-start;
                            border-bottom: 1px solid #FFFFFF1A;

                            > div {
                              display: flex;
                              flex-direction: column;
                              justify-content: center;
                              align-items: flex-start;

                              > span:first-child {
                                font-family: Poppins;
                                font-weight: 700;
                                font-size: 13px;
                                line-height: 100%;
                                max-width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                text-wrap: nowrap;
                                display: inline-block;
                                margin-bottom: 2px;
                              }
                              > span:nth-child(2) {
                                display: flex;
                                > span {
                                  font-family: Poppins;
                                  font-weight: 400;
                                  font-size: 11px;
                                  line-height: 100%;
                                  margin-bottom: 2px;
                                }
                                > strong {
                                  font-family: Poppins;
                                  font-weight: 600;
                                  font-size: 11px;
                                  line-height: 100%;
                                }
                              }
                              > span:last-child {
                                font-family: Poppins;
                                font-weight: 400;
                                font-size: 11px;
                                line-height: 100%;
                                max-width: 100%;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                text-wrap: nowrap;
                                display: inline-block;
                              }
                            }
                          }

                          &.td-date {
                            color: rgba(255, 255, 255, 0.6);
                            width: 80px;
                            text-align: right;
                            font-size: 10px;
                            font-weight: 400;
                            line-height: 13px;
                            padding-right: 0px;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        > .buttons {
          display: flex;
          gap: 10px;
          justify-content: center;
          align-items: center;
          > a {
            width: 100%;
            height: 40px;
            border-radius: 12px;
            font-size: 13px;
            line-height: 13px;
          }
        }
      }
    }
  }
</style>
